var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10",
    width: 6,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.067 1.366 3.693 5 .067 8.634 1.183 9.75 5.933 5 1.183.25.067 1.366z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrowDark);
export default __webpack_public_path__ + "static/media/button-arrow-dark.11adca68386cf6e2298d9e3477fabdcd.svg";
export { ForwardRef as ReactComponent };